import {Injectable} from '@angular/core';
import {Product} from '../data/product';
import {ConnectionHttpService, ResponseResult} from '@softline/core';
import {Scan} from '@softline/application';
import {
  CHARGE_RESOURCE_PATH,
  PRODUCT_IDENT_RESOURCE_PATH,
  PRODUCT_ITEM_RESOURCE_PATH,
  PRODUCT_QR_RESOURCE_PATH,
  SCAN_QUERY_RESOURCE_PATH,
  VALIDATE_SCAN_RESOURCE_PATH,
} from '../product-scan.api';
import {Observable} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

export class ItemNotFoundError extends Error { }
export class ValidateScanError extends Error { }

@Injectable()
export class ProductResourceService {
  constructor( private service: ConnectionHttpService) { }

  validateScan({ labelType, data }: Scan): Observable<Product> {
    if (labelType === 'qrcode')
      return this.service.get<any>({ path: PRODUCT_QR_RESOURCE_PATH, pathParams: { id: data }}).pipe(
        map(p => p.result)
      );

    return this.service.get<ResponseResult<number>>({path: VALIDATE_SCAN_RESOURCE_PATH, pathParams: { labelType, data }}).pipe(
      switchMap(o => {
        if (!o) {
          throw new ValidateScanError();
        }

        const path = labelType === 'ean13' || labelType === 'ean8'
          ? PRODUCT_ITEM_RESOURCE_PATH
          : PRODUCT_IDENT_RESOURCE_PATH;

        return this.service.get<any>({path, pathParams: {id: o.result}}).pipe(
          map(p => p.result)
        );
      })
    );
  }

  validateNumber(artNumber: number | string): Observable<Product> {
    return this.service
      .get<any, any>(
        {path: SCAN_QUERY_RESOURCE_PATH},
        {filter: '', multiValued: false, parameters: {kzgelistetall: false, sortierung: 2, artikelnummer: artNumber}}
      )
      .pipe(
        switchMap(o => {
          const ids = Object.keys(o?.data);
          if (ids.length !== 1) {
            throw new ItemNotFoundError();
          }

          return this.service.get<any>({path: PRODUCT_ITEM_RESOURCE_PATH, pathParams: {id: ids[0]}})
            .pipe(map(p => p?.result));
        }),
        catchError(error => {
            return this.service.get<any, any>(
                {path: CHARGE_RESOURCE_PATH},
                {filter: '' + artNumber, multiValued: false, parameters: {chargenummer: artNumber}}
            ).pipe(
              switchMap(p => {
                    console.log(p);
                    const ids = Object.keys(p?.data);

                    if (ids?.length !== 1) {
                        throw new ItemNotFoundError();
                    }

                    return this.service
                        .get<ResponseResult<Product>>({ path: PRODUCT_IDENT_RESOURCE_PATH, pathParams: {id: ids[0]} })
                        .pipe(map(o => o?.result));
              })
            );
        })
      );
  }
}
